import { client } from '@plugins/feathers'
import storage from '@shared/storage'

class Auth {

  get hasKey () {
    return this.userKey !== null
  }

  get userKey () {
    return storage.getItem('userKey')
  }

  private jwt: string

  constructor() {
    this.bindListeners()
  }

  public authenticate () {
    return new Promise(async (resolve, reject) => {
      const jwt = await client.passport.getJWT()

      if (jwt) {
        this.jwt = jwt
        try {
          const authenticated = await client.authenticate()
          return resolve(authenticated)
        } catch (error) {
          this.logout()
          location.reload()
        }
      }

      if (!this.hasKey) {
        return reject('Please login')
      }

      try {
        this.jwt = await client.authenticate({ key: this.userKey, strategy: 'key' })
        resolve(this.jwt)
      } catch (error) {
        this.logout()
        location.reload()
      }
    })
  }

  public logout () {
    storage.removeItem('userKey')
    storage.removeItem('metabola-jwt')
  }

  private bindListeners () {
    (client as any).io.on('reconnect', () => {
      client.authenticate()
        .catch((error) => {
          location.reload()
        })
    })
  }
}

export default new Auth()
